import { memo } from "react";

import "../Style/IndexWrapper.css"

const IndexWrapper = (props) => {

    // const indexLabel = [
    //     { content: "below 110 People", color: "#39AC50" },
    //     { content: "over 110 People to 240 People", color: "#F69D00" },
    //     { content: "over 240 People", color: "#E41630" },
    // ];

    return (
        <div className="index-wrapper">

            {

                props.index_label.map((item, index) =>
                    <span key={index} style={{ backgroundColor: item.color }}>  {item.content} </span>
                )
            }

        </div>
    );
};

export default memo(IndexWrapper);